import Api from '../../api/index'

const Dashboard = {
  namespaced: true,
  state: {
    value: 'my value',

    oneDashboard: null, //to store SHOW response
    allDashboards: null, //to store SHOW response

    dateFilter: null,

    //promises results
    createDashboardWasGood: null,
    createDashboardMessage: null,
    
    updateDashboardWasGood: null,
    updateDashboardMessage: null,

     // less used
    indexDashboardWasGood: null,
    indexDashboardMessage: null,

    showDashboardWasGood: null,
    showDashboardMessage: null,
  },
  getters: {
    getFilter: state => {
      return state.dateFilter;
    }
  },

  mutations: {
    setOneDashboard(state, Dashboard){
      state.oneDashboard = Dashboard.data.attributes // Dashboard.data
    },
    setAllDashboards(state, Dashboards){
      state.allDashboards = Dashboards.data.map(obj=>obj.attributes) // Dashboards.data
    },

    setDateFilter(state, filter){
      state.dateFilter = null
      state.dateFilter = []
      state.dateFilter[0] = filter.start_date // Dashboards.data
      state.dateFilter[1] = filter.end_date // Dashboards.data
    },
    clearDateFilter(state){
      state.dateFilter = null
    },

    

    clearAllDashboards(state){
      state.allDashboards = null
    },
    clearOneDashboard(state){
      state.oneDashboard = null
    },
  },

  actions: {
    clearAllDashboards({commit}){
      commit('clearAllDashboards')
    },
    clearOneDashboard({commit}){
      commit('clearOneDashboard')
    },

    setDateFilter({commit}, date_range){
      commit('setDateFilter', date_range)
    },
    clearDateFilter({commit}){
      commit('clearDateFilter')
    }
  }

};

export default Dashboard;